import React, { Suspense } from 'react';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';
import { Badge, BadgeProps, ErrorBoundary } from 'embeds/components';

import { BadgeChatActivityUnassigned_EmbedViewer$key } from './__generated__/BadgeChatActivityUnassigned_EmbedViewer.graphql';

export interface BadgeChatActivityUnassignedProps extends Omit<BadgeProps, 'classes'> {
  fragmentRef: BadgeChatActivityUnassigned_EmbedViewer$key;
}

const BadgeChatActivityUnassigned: React.FC<BadgeChatActivityUnassignedProps> = ({ fragmentRef, ...rest }) => {
  const viewer = useFragment<BadgeChatActivityUnassigned_EmbedViewer$key>(
    graphql`
      fragment BadgeChatActivityUnassigned_EmbedViewer on User {
        countUnassigned: chatActivityUnassignedCount
      }
    `,
    fragmentRef,
  );

  return <Badge badgeContent={viewer.countUnassigned} centerContent {...rest} />;
};

export default (props: BadgeChatActivityUnassignedProps) => (
  <ErrorBoundary fallback={null}>
    <Suspense fallback={null}>
      <BadgeChatActivityUnassigned {...props} />
    </Suspense>
  </ErrorBoundary>
);
